import React from "react";

import clsx from "clsx";
import TextareaAutosize from "react-textarea-autosize";

export interface RefPropsInterface {
  value?: string;
  readOnly?: boolean;
  valid?: boolean;
  invalid?: boolean;
  ref?: React.Ref<any>;
  children?: React.ReactNode;
  id?: string;
  name?: string;
  className?: string;
  placeholder?: string;
  onBlur?: (ev: React.FocusEvent<HTMLTextAreaElement>) => void;
  onChange?: (ev: React.ChangeEvent<HTMLTextAreaElement>) => void;
  spellCheck?: boolean;
}

interface PropsInterface {
  forwardedRef: React.Ref<any>;
}

type PropsType = RefPropsInterface & PropsInterface;

function TTTextAreaComponent({ forwardedRef, placeholder, children, valid, invalid, className, ...props }: PropsType) {
  const classes = clsx("form-control", className, {
    "is-invalid": invalid,
    "is-valid": valid,
  });

  return (
    <TextareaAutosize
      minRows={3}
      maxRows={15}
      className={classes}
      {...props}
      ref={forwardedRef}
      placeholder={placeholder}
    >
      {children}
    </TextareaAutosize>
  );
}

const TTTextArea = React.forwardRef<React.FunctionComponent, RefPropsInterface>((props, ref) => (
  <TTTextAreaComponent {...props} forwardedRef={ref} />
));

export default TTTextArea;
